import { postRequestFactory, createClient, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

export interface StopTransactionCommand {
  id: string; // TODO consider renaming this to transactionId .. this is kind of /sad
}

const client = createClient('/rest/operator-api/charging-stations');

export const stopTransaction: SaveOperation<StopTransactionCommand, void, string> = postRequestFactory<
  StopTransactionCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/stop-transaction',
  permissionId: commandPermissions.STOP_TRANSACTION
});
